import React, { useEffect, useState } from "react";
import s from "../styles.module.css";
import CustomInput from "../../../shared/components/CustomInput";
import { useDispatch, useSelector } from "react-redux";
import { contactFields } from "../../../data/Fields";
import { useForm } from "react-hook-form";
import { updateContacts, getContacts, createContact } from "../model/contacts";
import useAuth from "../../../hooks/useAuth";

function Contacts() {
  const dispatch = useDispatch();
  const { contacts, status } = useSelector((state) => state.contacts);
  const { auth } = useAuth();
  const access_token = auth?.access_token;
  const [loadingData, setLoadingData] = useState(false);
  const [loadingError, setLoadingError] = useState(null);
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {},
  });

  useEffect(() => {
    if (access_token) {
      setLoadingData(true);
      dispatch(getContacts())
        .then(() => setLoadingData(false))
        .catch((error) => {
          setLoadingData(false);
          setLoadingError(error.message);
        });
    }
  }, [dispatch, access_token]);

  useEffect(() => {
    if (contacts && Object.keys(contacts).length > 0) {
      reset(contacts);
    }
  }, [contacts, reset]);

  const onSubmit = (data) => {
    if (!contacts || Object.keys(contacts).length === 0) {
      dispatch(createContact({ ...data, access_token }));
    } else {
      dispatch(updateContacts({ ...data, access_token }));
    }
  };

  if (loadingData) {
    return (
      <div className="loadingContainer">
        <div className="loader"></div>
      </div>
    );
  }
  if (loadingError) {
    return (
      <div className="errorDataBox">
        <p>{loadingError}</p>
      </div>
    );
  }

  return (
    <div className="container">
      <h1 className="title">Контакты</h1>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className={s.block}>
          {contactFields.map((field) => (
            <CustomInput
              key={field.name}
              name={field.name}
              label={field.label}
              placeholder={field.placeholder}
              type={field.type}
              {...register(field.name)}
              error={!!errors[field.name]}
              helperText={errors[field.name]?.message}
            />
          ))}

          <div className="centerLoading">
            {status === "loading" ? (
              <div className="loader"></div>
            ) : (
              <button type="submit" className="saveButton">
                Добавить контакт
              </button>
            )}
          </div>
        </div>
      </form>
    </div>
  );
}

export default Contacts;
